import { Dispatch, SetStateAction, useState } from 'react';

import { Button } from '@gearbelt/ui/components';

import magnifyingGlass from '@/assets/signup/magnifying-glass.svg';
import UsersIcon from '@/components/icons/users';
import { SignUpSteps, useSignUpStore } from '@/stores/signup.store';

export const UsedDomainStep = () => {
  const [showHowToInviteModal, setShowHowToInviteModal] = useState(false);

  return <>{showHowToInviteModal ? <HowToInviteUsersMessageModal /> : <UsedDomainModal setShowHowToInviteModal={setShowHowToInviteModal} />}</>;
};

export const UsedDomainModal = ({ setShowHowToInviteModal }: { setShowHowToInviteModal: Dispatch<SetStateAction<boolean>> }) => {
  const {
    signUpForm: { email },
    setSignUpStep,
  } = useSignUpStore();
  const domain = email.split('@')[1];

  return (
    <>
      <div className="flex flex-col items-center justify-center gap-4">
        <img src={magnifyingGlass} alt="magnifying glass" />
        <h2 className="text-center text-xl font-bold">A workspace under @{domain} exists</h2>
        <div className="text-default-text text-center text-sm">
          A Gearbelt workspace account already exists using the <span className="font-bold">@{domain}</span> domain. By signing up you will not gain access to
          any existing company workspaces.
        </div>
        <div className="text-default-text text-center text-sm">Are you sure you want to continue?</div>
      </div>
      <div className="flex flex-col gap-2">
        <Button size="lg" className="mt-3 w-full py-2 text-sm font-medium" type="button" onClick={() => setSignUpStep(SignUpSteps.UserInfo)}>
          Yes, I want my own workspace
        </Button>
        <Button variant="grey" size="lg" className="w-full py-2 text-sm font-medium" type="button" onClick={() => setShowHowToInviteModal(true)}>
          No, I need to join an existing workspace
        </Button>
      </div>
    </>
  );
};

const HowToInviteUsersMessageModal = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center gap-4">
        <UsersIcon />
        <div className="text-default-text text-center text-sm">
          Please contact your company or site administrator and ask them to invite you to the existing Gearbelt workspace using your work email address.
        </div>
        <div className="text-default-text text-center text-sm">You can send them this article on how to invite you:</div>
      </div>
      <div className="flex flex-col items-center justify-center gap-2">
        <a href="https://help.sitemate.com/en/articles/9923356-how-to-add-users-to-your-gearbelt-workspace" target="_blank" rel="noreferrer">
          <Button size="lg" className="m-auto p-2 text-sm" type="button">
            How to invite users
          </Button>
        </a>
      </div>
    </>
  );
};
